import PatchOps from '@leverege/api-patch-ops'

import { updateProject } from './ProjectActions'

/*
  Usage:
    let updater = ProjectUpdater( dispatch, project )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done();
 */

function ProjectUpdater( dispatch, project, key, value ) {
  
  const patchOps = PatchOps( key, value );

  patchOps.done = function( ) {
    dispatch( updateProject( project, patchOps.ops() ) );

  }  

  return patchOps;
}

module.exports = ProjectUpdater;
